import { Component, AfterViewInit } from '@angular/core';
import { MessageService } from 'primeng/api';
//import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-comex-virtual-page',
  templateUrl: './comex-virtual-page.component.html',
  styleUrls: ['./comex-virtual-page.component.css'],

})
export class ComexVirtualPageComponent implements AfterViewInit {


  ngAfterViewInit() {
    this.setupObserver();
    this.checkInitialVisibility();  // Comprobamos la visibilidad al cargar la página
  }

  setupObserver() {
    // Creamos el IntersectionObserver
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');  // Añadimos la clase 'visible'
        }
      },
      {
        threshold: 0.5  // El 50% del elemento debe estar visible
      }
    );

    // Seleccionamos todos los elementos con la clase 'fade-in'
    const fadeInElements = document.querySelectorAll('.fade-in-js, .fade-in-up-js, .fade-in-right-js, .fade-in-left-js');
    fadeInElements.forEach((element) => {
      observer.observe(element);
    });
  }

  // Chequeamos manualmente la visibilidad de los elementos en la carga inicial
  checkInitialVisibility() {
    setTimeout(() => {
      const fadeInElements = document.querySelectorAll('.fade-in-js, .fade-in-up-js, .fade-in-right-js, .fade-in-left-js');
      fadeInElements.forEach((element) => {
        const rect = element.getBoundingClientRect();
        // Si el elemento está dentro del 50% del viewport, lo marcamos como visible
        if (rect.top <= window.innerHeight * 0.5 && rect.bottom >= 0) {
          element.classList.add('visible');  // Forzamos la clase 'visible'
        }
      });
    }, 100);  // Le damos un pequeño retraso para asegurar que el DOM esté completamente cargado
  }
}
